import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();


  if (document.body.classList.contains('contact') ) {
    const topValidationInterface = topValidation('zip', 'address01', 'address02');
    topValidationInterface.autoFillAddress('zip2', 'address04', 'address05');
  }

  var rellax = new Rellax('.rellax', {
  });



  const anchorSpace = window.innerHeight * 0.1; // 5vw
  const lenis = new Lenis({
    duration: 1.8, // スクロールの持続時間（秒）。デフォルトは1.2
    lerp: 0.05,     // 慣性の強さ。値が小さいほど「ゆったり」止まります（デフォルトは0.1程度）
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // 指数関数的なイージング
    smoothWheel: true
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  document.addEventListener('tccf7:scrollTo', e => {
    const header = document.querySelector('.anchor-header');
    const headerHeight = header ? header.offsetHeight : 0;

    lenis.scrollTo("#" + e.detail.id, {
      offset: -headerHeight,
      duration: 1.2,
      easing: (t) => 1 - Math.pow(1 - t, 3)
    });
  });


  // ページ内リンク対応
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', e => {
      const targetId = anchor.getAttribute('href');
      const target = document.querySelector(targetId);

      if (!target) return;

      e.preventDefault();

      lenis.scrollTo(target, {
        offset: -anchorSpace,       // 固定ヘッダーあるなら調整
        duration: 1.2,   // スクロール時間
        easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      });
    });
  });





  // ヘッダー関連の処理
  const header = document.querySelector('.header');
  const menuBtn = document.querySelector('.menu-btn');

  if (header) {

    const checkFixed = () => {
    const scrollY = window.scrollY;
    const vh100 = window.innerHeight;
    const windowWidth = window.innerWidth;

    if (windowWidth <= 768) {
      // SPは常に固定
      header.classList.add('is-fixed_hd');
    } else {
      // PCは100vh超えたら固定
      if (scrollY >= vh100) {
        header.classList.add('is-fixed_hd');
      } else {
        header.classList.remove('is-fixed_hd');
      }
    }
  };

  // 初期表示時
  checkFixed();

  // スクロール・リサイズ
  window.addEventListener('scroll', checkFixed);
  window.addEventListener('resize', checkFixed);
  window.addEventListener('load', checkFixed);

  // menuボタン
  if (menuBtn) {
    menuBtn.addEventListener('click', () => {
      header.classList.toggle('is-open');
      menuBtn.classList.toggle('is-open');
    });
  }

  }

  // サイドバー関連の処理
  const sideBar = document.querySelector('.side-sticky');
  const sideBtn = document.querySelector('.side-btn');

  // menuボタン
  if (sideBtn) {
    sideBtn.addEventListener('click', () => {
      sideBar.classList.toggle('is-open');
    });
  }



  const getSpace = () => Math.min(window.innerWidth * 0.05, 35);
  const swiper = new Swiper('.index-introduction-slide-inner', {
    loop: true,
    centeredSlides: true,
    slidesPerView: 1.5,
    spaceBetween: getSpace(),
    speed: 10000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
    },
    breakpoints: {
      768: {
        slidesPerView: 3.8,
      },
    },
  });





  const items = document.querySelectorAll('.index-bg-content');

  const update = () => {
    const triggerY = window.innerHeight * 0.45;

    items.forEach(item => {
      const rect = item.getBoundingClientRect();

      // 要素内に20%ラインがある間だけON
      if (rect.top <= triggerY && rect.bottom > triggerY) {
        item.classList.add('is-change');
      } else {
        item.classList.remove('is-change');
      }
    });
  };

  // 初期表示（リロード）
  update();
  // スクロール
  window.addEventListener('scroll', update, { passive: true });
  // リサイズ
  window.addEventListener('resize', update);



  const targets = document.querySelectorAll('.business-introduction-image');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const el = entry.target;
      const rect = el.getBoundingClientRect();
      const triggerLine = window.innerHeight * 0.5;

      if (entry.isIntersecting) {
        // 50%ラインに入ったら付与
        el.classList.add('is-scale');
      } else {
        // 上に戻ったときだけ外す
        if (rect.top > triggerLine) {
          el.classList.remove('is-scale');
        }
      }
    });
  }, {
    root: null,
    rootMargin: '-50% 0px -50% 0px',
    threshold: 0
  });

  targets.forEach(target => observer.observe(target));



  const $accordions = document.querySelectorAll('.js-accordion');
  const accordionSlideOptions = {
    duration: 500,
    easing: 'ease'
  };

  $accordions.forEach($accordion => {
    const $accordionBody = $accordion.querySelector('.js-accordion-body');

    $accordion.addEventListener('click', (e) => {
      // summary のネイティブ挙動を無効化
      if (e.target.closest('summary')) {
        e.preventDefault();
      }

      // 開く
      if (!$accordion.open) {
        $accordion.open = true;
        $accordionBody.animate(
          { height: ['0px', `${$accordionBody.scrollHeight}px`] },
          accordionSlideOptions
        );

      // 閉じる
      } else {
        const closeAnimation = $accordionBody.animate(
          { height: [`${$accordionBody.scrollHeight}px`, '0px'] },
          accordionSlideOptions
        );

        closeAnimation.addEventListener('finish', () => {
          $accordion.open = false;
        });
      }
    });
  });




  const sections = document.querySelectorAll('.business-content-inner section');
  const navLinks = document.querySelectorAll('.side-sticky a');

  const sideNavObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.getAttribute('id');

          navLinks.forEach(link => {
            link.classList.toggle(
              'current',
              link.getAttribute('href') === `#${id}`
            );
          });
        }
      });
    },
    {
      root: null,
      rootMargin: '-40% 0px -60% 0px',
      threshold: 0
    }
  );

  sections.forEach(section => sideNavObserver.observe(section));





  const cta = document.querySelector('.cta');
  const bg = document.querySelector('.cta-bg');
  const contentBg = document.querySelector('.cta-content-bg');
  const contentBlock = document.querySelector('.cta-content-block');

  const onScroll = () => {
    const vh = window.innerHeight;
    const ctaRect = cta.getBoundingClientRect();

    // 👉 CTA上端が画面上端に来るまで一切発火させない
    if (ctaRect.top > 0) {
      [bg, contentBg, contentBlock].forEach(el => {
        el.classList.remove('is-fixed', 'is-end');
      });
      return;
    }

    // CTA上端が画面上端についてからのスクロール量
    const startY = -ctaRect.top;

    // CTA下端が画面下端に到達したら終了
    const isEnd = ctaRect.bottom <= vh;

    /* ===== cta-bg ===== */
    if (isEnd) {
      bg.classList.add('is-end');
      bg.classList.remove('is-fixed');
    } else {
      bg.classList.add('is-fixed');
      bg.classList.remove('is-end');
    }

    /* === cta-content-bg === */
    if (isEnd) {
      contentBg.classList.add('is-end');
      contentBg.classList.remove('is-fixed');
    } else if (startY >= vh * 0.4) {
      contentBg.classList.add('is-fixed');
      contentBg.classList.remove('is-end');
    } else {
      contentBg.classList.remove('is-fixed', 'is-end');
    }

    /* === cta-content-block === */
    if (isEnd) {
      contentBlock.classList.add('is-end');
      contentBlock.classList.remove('is-fixed');
    } else if (startY >= vh * 0.7) {
      contentBlock.classList.add('is-fixed');
      contentBlock.classList.remove('is-end');
    } else {
      contentBlock.classList.remove('is-fixed', 'is-end');
    }
  };

  window.addEventListener('scroll', onScroll);
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', onScroll);




  const thumbEl = document.querySelector('.thumb-swiper');

  if (thumbEl) {

    // min(5vw, 35px) をJSで再現
    function getSpaceBetween() {
      return Math.min(window.innerWidth * 0.05, 35);
    }

    // 初期値
    let space = getSpaceBetween();

    const thumbSwiper = new Swiper('.thumb-swiper', {
      spaceBetween: space,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
    });

    const mainSwiper = new Swiper('.main-swiper', {
      spaceBetween: space,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: thumbSwiper,
      },
    });

    // リサイズ対応
    window.addEventListener('resize', () => {
      const newSpace = getSpaceBetween();

      if (newSpace !== space) {
        space = newSpace;

        thumbSwiper.params.spaceBetween = space;
        mainSwiper.params.spaceBetween  = space;

        thumbSwiper.update();
        mainSwiper.update();
      }
    });

  }




  const awardSwiper = document.querySelector('.company-award-swiper');

  if (awardSwiper) {
    const getSpaceBetween = () => Math.min(30, window.innerWidth * 0.05);

    const swiper = new Swiper('.company-award-swiper', {
      loop: true,
      slidesPerView: 1.8,
      spaceBetween: getSpaceBetween(),
      speed: 6000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 3.2,
        },
      },
    });

    // 画面リサイズ時にも追従させたい場合
    window.addEventListener('resize', () => {
      swiper.params.spaceBetween = getSpaceBetween();
      swiper.update();
    });
  }





  const reason = document.querySelector('.index-reason');

  if (reason) {
    window.addEventListener('scroll', () => {
      const rect = reason.getBoundingClientRect();

      // 要素の上端が画面上端に来た or 超えたら
      if (rect.top <= 0) {
        reason.classList.add('is-scroll');
      } else {
        reason.classList.remove('is-scroll');
      }
    });
  }


  // 横スクロール関連の処理
  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('.horizontal');
  if (section) {
    const inner = section.querySelector('.horizontal-inner');
    if (inner) {

      window.addEventListener('load', () => {

        const mm = gsap.matchMedia();

        mm.add("(min-width: 769px)", () => {

          const scrollLength = inner.scrollWidth - window.innerWidth;

          gsap.to(inner, {
            x: -scrollLength,
            ease: 'none',
            scrollTrigger: {
              trigger: section,
              start: 'top top',
              end: () => `+=${scrollLength}`,
              scrub: true,
              pin: true,
              invalidateOnRefresh: true,
            }
          });

        });

      });

    }
  }

});
